import { Button, Flex, Box, SimpleGrid } from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import { useState } from 'react';

export default function FeatureList({ features, columns, buttonLeft }: any) {
  const [showFull, setShowFull] = useState(false);

  const data = features ? (showFull ? features : features.slice(0, 6)) : [];

  return (
    <>
      <SimpleGrid
        columns={{
          base: 1,
          md: columns || 3,
        }}
        spacing={4}
      >
        {data.map((feature: any) => (
          <Box key={feature.id}>
            <CheckCircleIcon marginRight={2} color="green.500" />
            {feature.name}
          </Box>
        ))}
      </SimpleGrid>
      {!showFull && features.length > 6 && (
        <Flex
          justifyContent={buttonLeft ? 'flex-start' : 'center'}
          marginTop={8}
        >
          <Button size="sm" variant="outline" onClick={() => setShowFull(true)}>
            Alle Ausstattungsmerkmale anzeigen
          </Button>
        </Flex>
      )}
    </>
  );
}
